import * as React from 'react'
import {
  Text,
  Colors,
  InlineChildren,
  StackChildren,
} from '@doordash/design-language'
import { formatTimestamp } from '../utilities'
import CircleIcon from './CircleIcon'
import { CircleContainer } from '../delivery-issue-details/styles'

export type DateStoreHeadingType = {
  createdAt: string
  storeName: string
}

const DateStoreNameHeading: React.FC<DateStoreHeadingType> = ({
  createdAt,
  storeName,
}) => (
  <StackChildren size={StackChildren.Sizes.XxSmall}>
    <InlineChildren size={InlineChildren.Sizes.XxSmall}>
      <Text
        size={Text.Sizes.S14}
        color={Colors.TextTertiary}
        styles={Text.Styles.SectionSubtext}
      >
        {formatTimestamp(createdAt)}
      </Text>
      <CircleContainer>
        <CircleIcon size={4} color={Colors.TextTertiary} />
      </CircleContainer>
      <Text
        size={Text.Sizes.S14}
        color={Colors.TextTertiary}
        styles={Text.Styles.SectionSubtext}
      >
        {storeName}
      </Text>
    </InlineChildren>
  </StackChildren>
)

export default DateStoreNameHeading
